import {Button, styled} from '@mui/material'

const StyledButton = styled(Button)(() => ({
  minHeight: '42px',
  padding: '8px 32px'
}))

export default StyledButton
